import Splide from '@splidejs/splide';

const EL = '.js-podcasts';
const ACTIVE_CLASS = 'is-active';
const ELS = document.querySelectorAll(EL);

ELS.forEach((EL) => {
  var splide = new Splide(EL, {
    type: 'scroll',
    arrows: true,
    pagination: false,
    perMove: 1,
    fixedWidth: '363px',
    gap: 40,
    breakpoints: {
        1024: {
            fixedWidth: '250px',
            gap: 14,
        },
        767: {
            pagination: true,
            arrows: false,
        }
    }
  }).mount();

  function updateSlideInfo() {
    var currentSlideIndex = splide.index + 1;
    var totalSlides = splide.length;

    document.querySelector('.podcasts__actual').innerText = currentSlideIndex;
    document.querySelector('.podcasts__total').innerText = totalSlides;
  }

  splide.on('moved', updateSlideInfo);
  updateSlideInfo();
});
